import { MainRoutes } from '../app/core/enums';
import { AuthConfig } from '@auth0/auth0-angular';

export const prod_fe_uri = 'https://locations.g-experts.net';

export const BASE_AUTH_CONFIG = {
  domain: 'login.g-experts.net',
  clientId: '2XW1LNVIVGfFvtSgeyBuxCaoI9oxg1HC',

  // BLS-4568 to prevent unnecessary redirects to the auth0 domain upon page reload
  useRefreshTokens: true,
  cacheLocation: 'localstorage',

  authorizationParams: {
    // FE base URL
    redirect_uri: prod_fe_uri + '/',
    audience: prod_fe_uri + '/',
  },
  errorPath: MainRoutes.ERROR,
} as AuthConfig;

export const environment = {
  production: true,
  providers: [], // don't show store dev tools in PROD at all
  staging: false,
  activeFeatures: {
    gxWrapped: false,
    campaignsTour: false,
    landingPages: false,
    aiInsightsTour: false,
    reviewTranslationTour: false,
    rebrandingTour: true,
    dev: {
      xhrInterceptionAndLogout: false,
      claimAndCleanMocking: false,
      showGoogleUpdateValueColumn: false,
    },
  },
  // outgoing API requests
  // will be overwritten by build script when running build pipeline
  baseURL: '',
  // needs to be set manually
  baseAgentUrl: 'https://agentic-service-gateway-b4g81m9f.ew.gateway.dev',
  auth0: BASE_AUTH_CONFIG
};
